"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDaysWithShifts = void 0;
const luxon_1 = require("luxon");
const ShiftType_1 = require("./models/shifts/ShiftType");
function useDaysWithShifts({ schedule }) {
    if (!schedule) {
        return [];
    }
    const dateToShiftsMap = convertRawScheduleResponseToRawShifts(schedule);
    const shiftsDays = [];
    const dateToShifts = Array.from(dateToShiftsMap.entries()).reduce((json, [key, value]) => {
        json[key] = value;
        return json;
    }, {});
    Object.entries(dateToShifts).forEach(([date, shiftInformationList]) => {
        if (shiftInformationList.some((shiftInformation) => shiftInformation.shift_type === ShiftType_1.ShiftType.REGULAR ||
            shiftInformation.shift_type === ShiftType_1.ShiftType.SUPPLEMENTARY)) {
            shiftsDays.push(date);
        }
    });
    return shiftsDays
        .map((punch) => (punch ? luxon_1.DateTime.fromISO(punch) : null))
        .filter((dateTime) => !!dateTime);
}
exports.useDaysWithShifts = useDaysWithShifts;
function convertRawScheduleResponseToRawShifts(response) {
    var _a;
    const dateToShiftsMap = new Map();
    for (const shift of response.schedules) {
        const rawShift = convertShiftResponseToRawShift(shift);
        const key = luxon_1.DateTime.fromISO(rawShift.shift_segments[0].time_period.start).toISODate();
        if (dateToShiftsMap.has(key)) {
            (_a = dateToShiftsMap.get(key)) === null || _a === void 0 ? void 0 : _a.push(rawShift);
        }
        else {
            dateToShiftsMap.set(key, [rawShift]);
        }
    }
    return dateToShiftsMap;
}
function convertShiftResponseToRawShift(shiftResponse) {
    return {
        shift_segments: [convertShiftResponseToRawShiftSegment(shiftResponse)],
        shift_type: mapShiftTypeToRawShiftType(shiftResponse.shiftType),
        site: shiftResponse.site
    };
}
function convertShiftResponseToRawShiftSegment(shiftResponse) {
    return {
        time_period: {
            start: shiftResponse.startAt,
            end: shiftResponse.endAt
        },
        breaks: convertBreakResponseToRawBreaks(shiftResponse.metadata),
        anomalies: []
    };
}
function convertBreakResponseToRawBreaks(metadata) {
    const rawBreaks = [];
    if (metadata && metadata.breaks) {
        for (const breakPeriod of metadata.breaks) {
            const rawBreak = {
                start: breakPeriod.startAt,
                end: breakPeriod.endAt
            };
            rawBreaks.push(rawBreak);
        }
    }
    return rawBreaks;
}
function mapShiftTypeToRawShiftType(shiftType) {
    const shiftEnumType = ShiftType_1.ShiftType[shiftType];
    if (!shiftEnumType) {
        return ShiftType_1.ShiftType.UNSUPPORTED;
    }
    return shiftEnumType;
}
